import React from 'react';

const steps = [
    { title: 'Ouvrez votre compte', description: "Votre email vous permet de vous inscrire et d’accéder à nos services en quelques minutes." },
    { title: 'Répondez à quelques questions', description: "Vos réponses nous permettent de mieux comprendre vos attentes." },
    { title: 'Créditez votre wallet', description: "Votre argent est séquestré chez notre partenaire monétique Lemonway dans des banques partenaires." },
    { title: 'Vous êtes prêts à investir !', description: "Effectuez des offres de prêt aux entreprises rigoureusement sélectionnées par PretUp." }
];

const Stepper = () => {
    return (
        <div className="mb-20 text-center mx-auto sm:px-6 lg:px-8">
            <div>
                {steps.map((step, index) => (
                    <div key={index} className="step-item transition-transform transform hover:scale-105">
                        <div className="flex flex-col items-center mb-4">
                            <div className="w-10 h-10 bg-secondary rounded-full flex items-center justify-center ring-8 ring-white shadow-lg">
                                <span className="text-white font-bold">{index + 1}</span>
                            </div>
                            <h3 className="text-lg font-semibold mt-4 text-secondary">
                                {step.title}
                            </h3>
                        </div>
                        <p className="mb-6 px-10 text-gray-700">
                            {step.description}
                        </p>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Stepper;
